// src/AnimationView/functions/misc.ts
/**
 * Fonction pour surligner un bloc Blockly.
 * @param blockId - Identifiant du bloc.
 */
export const highlightBlock = (blockId: string) => {
    (window as any).Blockly?.getMainWorkspace()?.highlightBlock(blockId);
};
